import { apiClient } from "./client";

export type RiskLevel = "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";

export type ForecastRow = {
  year: number;
  month: number;
  demand_slots: number;
  expected_filled: number;
  estimated_gap: number;
  gap_ratio: number;
  risk_level: RiskLevel;
  is_already_planned: boolean;
};

export type ForecastReport = {
  organization_id: string;
  lookback_months: number;
  months_ahead: number;
  baseline_coverage_rate: number;
  baseline_samples: number;
  active_practitioners: number;
  rows: ForecastRow[];
};

export async function getCoverageForecast(
  organizationId: string,
  params: { months_ahead?: number; lookback?: number } = {},
): Promise<ForecastReport> {
  const { data } = await apiClient.get<ForecastReport>(
    "/api/v1/admin/coverage-forecast",
    {
      params: { organization_id: organizationId, ...params },
    },
  );
  return data;
}
